module.exports = __webpack_public_path__ + "c927a5e5aac59343c2ea070cf65fb6ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.png
// module id = 208
// module chunks = 1